<template>
	<div class="innerBox mt-3">
		<!-- <h2 class="title">Tambah Pemakaian Bahan / Lainnya</h2> -->
		<!-- {{usageList}} -->
		<div class="row pl-4 mt-2 mb-3">
			<div class="col-md-4 col-6 text-left" style="margin-top:auto;margin-bottom:auto;">
				<h6>Daftar Pemakaian Bahan dan Lainnya </h6>
			</div>
		
		</div>
		<div class="pl-3 pr-3">
			<table class="table table-border">
				<thead>
					<th>No.</th>
					<th>Tipe Sparepart</th>
					<th>Nama Jasa / Part</th>
					<th>Jumlah Terpakai</th>
					<th>Perkiraan Pemakaian</th>
					<th>Nama Pekerja</th>
					<th>Waktu Pengambilan</th>
					<th>Harga / Item</th>
					<th><i class="fa fa-cog"></i></th>
				</thead>
				<tbody v-if="usageList.length > 0">
					<template  v-for="(sparepart , index) in usageList.filter(x => x.inventoryDetails.sparepart_type == 'B')" >
					<tr :key="index" v-if="sparepart.inventoryDetails">
						<td>{{index + 1}}</td>
						<td>{{sparepart.inventoryDetails ? sparepart.inventoryDetails.sparepart_type : 'Loading....'}}</td>
						<td>{{sparepart.inventoryDetails ? sparepart.inventoryDetails.sparepart_name : 'Loading....'}}</td>
						<td>{{numberWithCommas(sparepart.amount)}}</td>
						<td>{{numberWithCommas(sparepart.used_amount)}}</td>
						<td>{{options.laborer.find(x => x.id == sparepart.labourer_id) ? options.laborer.find(x => x.id == sparepart.labourer_id).name : '-'}}</td>
						<td>{{sparepart.inventoryDetails ? moment(sparepart.updated_at).format('Y-MM-DD HH:mm') : 'Loading...'}}</td>
						<td>Rp. {{sparepart.average_price_usage ? sparepart.average_price_usage : 0}}</td>
						<td>
							<button class="btn btn-outline-info" type="button" name="Liat Tanda Tangan Pekerja" @click="selectImage = sparepart.sign_pic;labor_name = options.laborer.find(x => x.id == sparepart.labourer_id).name"><i class="fa fa-signature"></i></button>
						</td>
					</tr>
					</template>
				</tbody>
			</table>
		</div>


		<div class="row row-space">
			<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
				<div class="input-group">
					<label class="label">Pilih Bahan / Lainnya<span style="color: red;">*</span></label>
				</div>
			</div>
		</div>
		<div class="row row-space pl-3" style="margin-top:-15px">
			
			<div class="col-md-8 col-12 row" style="padding-top:6px;">
				
				<div class="col" style="padding-right:0">
					<button 
						style="border-radius : 6px 0px 0px 6px"
						type="button" 
						class="w-100 btn" 
						:class="{'btn-outline-primary' : sparepart_type != 'B', 'btn-primary' : sparepart_type == 'B'}" 
						@click="sparepart_type = 'B'"
					>
						Bahan
					</button>
				</div>
				<div class="col" style="padding-left:0">
					<button 
						style="border-radius : 0px 6px 6px 0px"
						type="button" 
						class="w-100 btn" 
						:class="{'btn-outline-primary' : sparepart_type != 'O', 'btn-primary' : sparepart_type == 'O'}" 
						@click="sparepart_type = 'O'"
					>
						Special Bahan
					</button>
				</div>
			</div>
		</div>

		<div class="row row-space mt-3">
			<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
				<div class="input-group">
					<label class="label">Pilih Pekerja<span style="color: red;">*</span></label>
					<MultiSelect 
						:options="options.laborer.map(x => x.id)"
						:custom-label="opt => options.laborer.find(x => opt == x.id).name"
						v-model="formEx.labourer_id"
					/>
				</div>
			</div>
		</div>

		<template v-if="sparepart_type == 'B'">
			<div class="row row-space mt-3">
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
					<div class="input-group">
						<label class="label">Pilih Jasa Pemakaian Bahan<span style="color: red;">*</span></label>
						<MultiSelect 
							:options="dataJasa.map(x => x.id)"
							:custom-label="opt => dataJasa.find(x => opt == x.id).sparepart_name"
							v-model="selectedJasa"
							:multiple="true"
						/>
						<button class="btn btn-info mt-3 mr-3" @click="selectAll">Pilih Semua</button>
						<button class="btn btn-danger mt-3" @click="reset">Reset</button>
					</div>
				</div>
			</div>

			<div class="row row-space" v-if="selectedJasa.length > 0">
				<div class="col-12">
					<div class="input-group">
						<label class="label">Pilih Bahan<span style="color: red;">*</span></label>
						<MultiSelect 
							:options="sparepartListBahan.map(x=> x.id)"
							:custom-label="opt => sparepartListBahan.find(x => opt == x.id).name"
							v-model="selectSparepart"
							:multiple="true"
						/>
					</div>
				</div>
			</div>
			<div v-if="sizeDetail.length > 0" class="row row-space">
				
				<div class="col-12">
					<hr>
					<div class="input-group">
						<label class="label">Rincian Bahan</label>
						<table class="table table-borderless">
							<tbody v-for="data in sizeDetail" :key="data.sparepart_name" >
								<tr>
									<td>Sparepart Size</td>
									<td>:</td>
									<td>{{data.name}}</td>
								</tr>
								<tr>
									<td>Sparepart Name</td>
									<td>:</td>
									<td>{{data.sparepart_name}}</td>
								</tr>
								<!-- <tr>
									<td>Perkiraan Pemakaian Sparepart</td>
									<td>:</td>
									<td>{{data.used_amount}}</td>
								</tr> -->
								<tr>
									<td>Pemakaian Sparepart</td>
									<td>:</td>
									<td><input type="text" class="form-control" v-model="data.amount"/></td>
								</tr>
								<tr>
									<td colspan="3"><hr></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="row pl-3 pr-3">
				<div class="col mt-5" style="text-align: center">
					<!-- <button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Kembali</button> -->
					<button type="button" class="btn btn-primary w-100" style="font-size:150%" @click="addSparepart()" :disabled="sizeDetail.length <= 0">Tambah</button>
				</div>
			</div>
			<div class="w-100 input-group">
				<h5>Bukti Foto Pemakaian Bahan</h5>
				<web-cam 
					:height="'100%'"
					:width="'100%'"
					:autoplay="true"
					:selectFirstDevice="true"
					ref="webcam"
				/>
			</div>
			<!-- <hr> -->

			

			
		</template>
		<template v-else>
			<div class="row row-space">
				<div class="col-12">
					<div class="input-group">
						<label class="label">Pilih Sparepart<span style="color: red;">*</span></label>
						<MultiSelect 
							:options="sparepartListOthers.map(x=> x.id)"
							:custom-label="opt => sparepartListOthers.find(x => opt = x.id).name"
							v-model="selectSparepart"
							:multiple="true"
						/>
					</div>
				</div>
			</div>
			
			<template v-if="sizeDetail.length > 0">
				
				<div class="row row-space" v-for="data in sizeDetail" :key="data.id">
				
					<div class="col-12">
						<div class="input-group">
							<label class="label">Rincian Sparepart</label>
							<table class="table table-borderless">
								<tr>
									<td>Sparepart Name</td>
									<td>:</td>
									<td>{{data.sparepart_name}}</td>
								</tr>
								<tr>
									<td>Sparepart ID</td>
									<td>:</td>
									<td>{{data.sparepart_id}}</td>
								</tr>
								<tr>
									<td>Pemakaian Sparepart</td>
									<td>:</td>
									<td><input type="text" class="form-control" v-model="data.amount"/></td>
								</tr>
							</table>
						</div>
					</div>
				</div>
			</template>

			<div class="w-100 input-group">
				<h5>Bukti Foto Pemakaian Bahan</h5>
				<web-cam 
					:height="'100%'"
					:width="'100%'"
					:autoplay="true"
					:selectFirstDevice="true"
					ref="webcam"
				/>
			</div>
			<hr>
			

			<div class="row">
				<div class="col mt-5" style="text-align: center">
					<button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Kembali</button>
					<button type="button" class="btn btn-primary ml-5" style="font-size:150%" @click="addSparepart()" :disabled="sizeDetail.length <= 0">Tambah</button>
				</div>
			</div>
		</template>

		<preview-image
			v-if="selectImage"
			@closeModal="selectImage = null"
			:title="'Bukti Pengambilan ' + labor_name"
			:image="env.baseImage + '/' + selectImage"
		></preview-image>
	</div>
</template>

 
</transition>
</template>

<script>
import MultiSelect from 'vue-multiselect'
import previewImage from '@/components/modal/previewImage'
import { WebCam } from "vue-web-cam";
import env from '@/env'
import moment from 'moment'
export default {
	components : {
		MultiSelect,
		previewImage,
		WebCam
	},
	data () {
		return {
			env,
			moment,
			options : this.$store.getters.getFilterOptions,
			sparepartListBahan : null,
			sparepartListOthers : null,
			sparepart_type : 'B',
			sparepart_size : null,
			selectedJasa : [],
			selectSparepart : [],
			size_list : [],
			formEx : {
				labourer_id : null,
				"sparepart_id": null,
				"amount": null,
				"used_amount" : null,
				"price_per_item": null,
				"transaction_description": '',
				"workorder_code": this.workOrderCode,
				'sign_pic' : null
			},
			model : {
				labourer_id : null,
				"sparepart_id": null,
				"amount": null,
				"used_amount" : null,
				"price_per_item": null,
				"transaction_description": '',
				"workorder_code": this.workOrderCode,
				'sign_pic' : null
			},
			sizeDetail : [],
			selectImage : null
		}
  	},
  	watch : {
		workOrderCode () {
			this.formEx.workorder_code = this.workOrderCode
			this.model.workorder_code = this.workOrderCode
		},
		
		selectedJasa () {
			this.size_list.length = 0;
			
			for(var i = 0 ; i < this.selectedJasa.length; i++) {
				let estimation = this.dataJasa.find(x => x.id == this.selectedJasa[i])
				this.size_list.push(estimation.sparepart_size)

			}	
			if(this.selectSparepart.length > 0)
				this.searchSparepartID(this.selectSparepart)
		},
		selectSparepart : {
			deep : true , 
			handler () {
				this.searchSparepartID(this.selectSparepart)
			}
			
			// console.log(this.selectSparepart)
		},
		sparepart_type () {
			this.size_list.length = 0;
			this.sizeDetail.length = 0;

			this.selectSparepart.length = 0
			this.selectedJasa.length = 0
		}
	},
	mounted () {
		this.getSparepartVariantsBahan()
		this.getSparepartVariantsOthers()
		// this.getInventoryUsageWO()
	},
	methods : {
		
		
		selectAll() {
			this.selectedJasa = this.dataJasa.map(x => x.id)
		},
		reset () {
			this.selectedJasa = []
		},
		undo() {
			this.$refs.signaturePad.undoSignature();
		},
		async takePicture() {
			let b64Data = this.$refs.webcam.capture().split('data:image/jpeg;base64,')[1]
			

			let contentType = 'image/jpeg';
			let sliceSize = 1024;

			var byteCharacters = atob(b64Data);
			var byteArrays = [];

			for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
				var slice = byteCharacters.slice(offset, offset + sliceSize);

				var byteNumbers = new Array(slice.length);
				for (var i = 0; i < slice.length; i++) {
					byteNumbers[i] = slice.charCodeAt(i);
				}

				var byteArray = new Uint8Array(byteNumbers);

				byteArrays.push(byteArray);
			}

			var blob = new Blob(byteArrays, {type: contentType});
			const blobUrl = URL.createObjectURL(blob);
			return blobUrl;

		},
		async addSparepart() {
			let data = await this.takePicture()

			let imageUrl = await this.submitPic(data);
			if(imageUrl == 'Error') return

			for(var i = 0 ; i < this.sizeDetail.length ; i++) {
				let data = Object.assign({}, this.sizeDetail[i])

				let form = Object.assign({} , this.formEx)
				form.sparepart_id  = data.sparepart_id
				form.used_amount = data.used_amount ? parseInt(data.used_amount) : 1
				form.amount = parseInt(data.amount) * -1
				form.price_per_item = 0
				form.transaction_description = `Pemakaian Barang ${data.sparepart_name} di ${this.workOrderCode}`
				form.sign_pic = imageUrl

				this.$http.post('/api/v1/inventory' , [form])
				.then((resp) => {
					this.$store.dispatch('triggerAlert', [true, [`Pemakaian Inventory Berhasil Disimpan`]]);
					// this.$emit('updateTable');
					// this.$emit('closeModal');
					this.$set(this , 'formEx' , this.model)
					this.reset()
					this.sizeDetail = []
					// this.getInventoryUsageWO()
					this.$emit('updateInventoryUsage')
				})
				.catch((err) => {

					let errObj = err.response.data

					this.$store.dispatch('triggerAlert' , [false, 'Duplicate Sparepart in the Estimation.'])
				})
			}
		},
		async submitPic(image) {
			try {
				let formData = new FormData()

				let data = await fetch(image).then(function(res){return res.arrayBuffer();}).then(function(buf){return new File([buf], 'ttdImage.png',{type:'image/png'});})
				formData.append('image' , data)

                let response = await this.$http.post(env.urlStart + '/api/v1/workorder/steps/upload' , formData , {headers : {"Content-Type":'multipart/form-data'}})
				
				return response.data.data.filename
			}
			catch(err) {
				this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong When Uploading Image'])
				console.log(err)
				return 'Error'
			}
		},
		async getDataSparepart(curSparepart) {
			try {
				let url = `/api/v1/masterData/sparepart`
				let response = await this.$http.get(url + `?variant_id=${curSparepart}`)
				return response;
			}
			catch(err) {
				console.log(err)
				this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong. Please Try Again Later.'])
			}
			
		},
		async searchSparepartID (sparepart) {
			console.log(sparepart , sparepart.length)

			this.sizeDetail.length = 0;
			

			for(var i = 0 ; i < sparepart.length ; i++) {
				let curSparepart = sparepart[i]
				let resp = await this.getDataSparepart(curSparepart) 
				let data = resp.data.data[0]

				if(this.sparepart_type == 'B') {

					let obj = {
						name : '',
						used_amount : 0,
						sparepart_name : data.sparepart_variants.name,
						sparepart_id : data.id
					}
					for(var j = 0 ; j < this.size_list.length ; j++) {
						let size_base = data.sparepart_sizes.find(x => x.size_base.id == this.size_list[j])
						obj.name += `${size_base.size_base.name} `
						obj.used_amount += size_base.value
					}

					this.sizeDetail.push(obj)
					
				}
				else {
					let obj = {
						amount : 0,
						sparepart_name : data.sparepart_variants.name,
						sparepart_id : data.id
					}

					this.sizeDetail.push(obj)
				}
			}
		},
		getSparepartVariantsBahan() {
			this.$http.get('/api/v1/masterData/sparepart/variants?sparepart_type_id=3&pagination=false')
			.then((resp) => {
				this.sparepartListBahan = resp.data.data
			})
			.catch((err) => {
				console.log(err)
				this.$store.dispatch('triggerAlert', [false, [err]]);
			})
		},
		getSparepartVariantsOthers() {
			this.$http.get('/api/v1/masterData/sparepart/variants?sparepart_type_id=4&pagination=false')
			.then((resp) => {
				this.sparepartListOthers = resp.data.data
			})
			.catch((err) => {
				console.log(err)
				this.$store.dispatch('triggerAlert', [false, [err]]);
			})
		}
	},
	props : ['dataJasa', 'estimation_id', 'workOrderCode' , 'usageList']
}
</script>

<style>

td {
	vertical-align: middle !important;
}

/* ==========================================================================
#form made by Colorlib (https://colorlib.com)
========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #666;
}

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding:20px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
  font-size: 40px;
  color: #525252;
  margin-bottom: 40px;
  text-align: center;
}


/* FILE DRAG N' DROP START */
.dropZone {
  /* width: 80%; */
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone:hover {
  border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
  color: #1975A0;
}

.dropZone-info {
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5C5C5C;
  opacity: 0.8;
}

.dropZone-uploaded {
  /* width: 80%; */
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}
/* FILE DRAG N' DROP END */


</style>
